import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const QuotationRequestDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'quotation-request',
        routeParamKey: 'quotationRequestId',
        pageTitle: 'Quotation Request Details',
        backRoute: '/quotation-requests',
        backLabel: 'Back to QuotationRequests',
        tabIdPrefix: 'quotation-request',
        tabsAriaLabel: 'quotation request detail tabs',
        missingIdMessage: 'No quotation request ID provided in the URL.',
        noDataMessage: 'No quotation request data available. The quotation request might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default QuotationRequestDetailPage;
